import O1HD from "../../../../engines/gameEngine";
import NormalGameManager from "../../manager/NormalGameManager";
import {BUNDLE_SMALL_NAME, getOneBundleOnePrefab} from "../../BundleResourceConfig";

const {ccclass, property} = cc._decorator;

@ccclass
export default class mineLandSelectPage extends cc.Component {

    @property(cc.Prefab)
    enterMineralNode : cc.Prefab = null;

    @property({type:cc.Prefab,displayName:"矿产预制体"})
    mineralPrefab:cc.Prefab = null;
    @property(cc.Label)
    xunBaoPrice : cc.Label = null;


    //矿地寻宝 价格
    private tanBaoPrice : number = 5000;

    start (  ){
        this.tanBaoPrice = Math.floor( NormalGameManager._instance.getPriceRate() * this.tanBaoPrice );
        this.xunBaoPrice.string = `${this.tanBaoPrice}`;
    }


    async onBtnOne(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if ( O1HD.getServices().userSrv.getCoins() < this.tanBaoPrice ) {
            NormalGameManager._instance.openBankPage();
            O1HD.getModules().uiControlModule.showMessageBox("您的资金不足");
            return;
        }
        O1HD.getServices().userSrv.setCoins( -this.tanBaoPrice , true );
        let url = "prefab/mineLandNode";
        let prefab = await getOneBundleOnePrefab( BUNDLE_SMALL_NAME.mineLandGameBundle , url );
        let mineLandPrefab = cc.instantiate(prefab);
        O1HD.Canvas().addChild( mineLandPrefab );
        // let enterMineralNode = cc.instantiate( this.enterMineralNode );
        // O1HD.Canvas().addChild( enterMineralNode );
    }

    onBtnTwo(){
        let mineralNode = cc.instantiate(this.mineralPrefab);
        O1HD.Canvas().addChild(mineralNode);
    }

    onBtnBack(){
        this.node.destroy();
        this.node.removeFromParent();
    }

    onDisable(){
        O1HD.emit("normalMode.onBackNormal","kd");
    }

}
